import script from "./AdminChatView.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminChatView.vue?vue&type=script&setup=true&lang=js"

import "./AdminChatView.vue?vue&type=style&index=0&id=0b9f7087&scoped=true&lang=css"
import "./AdminChatView.vue?vue&type=style&index=1&id=0b9f7087&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0b9f7087"]])

export default __exports__